import Axios from 'axios'
import * as React from 'react'
import {AlphaPicker, RGBColor, SliderPicker} from 'react-color'
import {connect} from 'react-redux'
import {v4 as uuidv4} from 'uuid'
import {CsSelectorLite} from '../../core/components/Controls/CsSelector'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {getDateString} from '../../core/helpers'
import {ISourcesDispatcher} from '../../core/interfaces/dispatchers'
import {ISourceDescription, ISourceDescriptions} from '../../core/interfaces/models'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {Feature} from '../../core/models'
import {ServiceHub} from '../../core/ServiceHub'
import {appSourcesDispatcher} from '../../dispatchers/appSourcesDispatcher'
import {getPlanName} from '../../helpers/regHelper'
import {IAppStore, IAppUser} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import {LocationSelector} from '../App/LocationSelector'
interface State {
  loading: boolean
  selectedSettlemet?: Feature
  selectedLocation?: Feature
  locationPlans: Feature[]
  selectedPlan?: Feature
  addChangesOnly: boolean
  exportedPlan: string
  exception: string
  success: string
  exportCs: CoordinateSystem
  parcels: {
    strokeColor: RGBColor
    fillColor: RGBColor
    textColor: RGBColor
  }
}

interface DispatchProps extends ISourcesDispatcher {}

interface ParentProps {}

interface OwnProps {
  layerInfos: IFeatureLayerInfos
  user?: IAppUser
}

type Props = DispatchProps & OwnProps & ParentProps
class StreetHistoryClass extends React.Component<Props, State> {
  confirmDeleteMsg = 'Моля, потвърдете изтриването като натиснете пак'
  confirmDeleteLocMsg = 'Потвърдете изтриването като натиснете пак'
  confirmDeletePlanMsg = 'Потвърдете изтриването като натиснете отново'
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: false,
      success: '',
      exportCs: CoordinateSystem.BG2005CAD,
      locationPlans: [],
      exportedPlan: '',
      exception: '',
      parcels: {
        strokeColor: {r: 255, g: 179, b: 0, a: 1},
        fillColor: {r: 255, g: 255, b: 0, a: 0},
        textColor: {r: 255, g: 120, b: 0, a: 1}
      },
      addChangesOnly: true
    }
  }

  setSelectedPlan(feature?: Feature) {
    this.setState({
      ...this.state,
      selectedPlan: feature
    })
  }

  getPlanSelector() {
    const ops: JSX.Element[] = []
    this.state.locationPlans.forEach((p, i) => {
      ops.push(
        <option key={i} value={p.getProperties()['Id']}>
          {getPlanName(p)}
        </option>
      )
    })
    if (ops.length == 0) {
      return null
    }
    return (
      <select
        className="form-control"
        value={this.state.selectedPlan ? this.state.selectedPlan.getProperties()['Id'] : ''}
        onChange={e => {
          const selectedPlan = this.state.locationPlans.find(
            p => parseInt(p.getProperties()['Id']) == parseInt(e.target.value)
          )
          this.setSelectedPlan(selectedPlan)
        }}
      >
        {ops}
      </select>
    )
  }

  getDeleteAll = () => {
    return (
      <>
        {this.state.exception == this.confirmDeleteMsg ? <div className="error-div">{this.state.exception}</div> : null}
        {this.props.user && (this.props.user.isAdmin || this.props.user.isRegAdmin) ? (
          <button
            type="button"
            disabled={!this.state.selectedSettlemet}
            className="button width"
            style={{backgroundColor: 'red'}}
            onClick={() => {
              if (this.state.exception) {
                this.setState({...this.state, exception: ''}, () => {
                  Axios.get(appConfig.urls.xyApiUrl + '/StreetDeleteAll/' + this.state.selectedSettlemet!.getId()).then(
                    r => {
                      this.setState({
                        ...this.state,
                        selectedLocation: undefined,
                        selectedSettlemet: undefined,
                        locationPlans: [],
                        selectedPlan: undefined
                      })
                      for (const id in this.props.layerInfos) {
                        this.props.layerInfos[id].refresh()
                      }
                    }
                  )
                })
              } else {
                this.setState({...this.state, exception: this.confirmDeleteMsg})
              }
            }}
          >
            Изчисти всички данни за населеното място
          </button>
        ) : null}
      </>
    )
  }
  getDeleteLocality = () => {
    return (
      <>
        {this.state.exception == this.confirmDeleteLocMsg ? (
          <div className="error-div">{this.state.exception}</div>
        ) : null}
        {this.props.user && (this.props.user.isAdmin || this.props.user.isRegAdmin) ? (
          <button
            type="button"
            disabled={!this.state.selectedLocation}
            className="button width"
            style={{backgroundColor: 'red'}}
            onClick={() => {
              if (this.state.exception) {
                this.setState({...this.state, exception: ''}, () => {
                  Axios.get(appConfig.urls.xyApiUrl + '/StreetDeleteLocality/' + this.state.selectedLocation!.getId())
                    .then(r => {
                      for (const id in this.props.layerInfos) {
                        this.props.layerInfos[id].refresh()
                      }
                      this.setState({
                        ...this.state,
                        selectedSettlemet: undefined,
                        selectedLocation: undefined,
                        selectedPlan: undefined,
                        locationPlans: []
                      })
                    })
                    .catch(e => {
                      if (e.response && e.response.data) {
                        this.setState({...this.state, exception: e.response.data})
                      }
                    })
                })
              } else {
                this.setState({...this.state, exception: this.confirmDeleteLocMsg})
              }
            }}
          >
            Изчисти всички данни за местността
          </button>
        ) : null}
      </>
    )
  }
  getDeletePlan = () => {
    return (
      <>
        {this.state.exception == this.confirmDeletePlanMsg ? (
          <div className="error-div">{this.state.exception}</div>
        ) : null}
        {this.props.user && (this.props.user.isAdmin || this.props.user.isRegAdmin) ? (
          <button
            type="button"
            disabled={!this.state.selectedPlan}
            className="button width"
            style={{backgroundColor: 'red'}}
            onClick={() => {
              if (this.state.exception) {
                this.setState({...this.state, exception: ''}, () => {
                  Axios.get(appConfig.urls.xyApiUrl + '/StreetDeletePlan/' + this.state.selectedPlan!.getId())
                    .then(r => {
                      for (const id in this.props.layerInfos) {
                        this.props.layerInfos[id].refresh()
                      }
                      this.setState({...this.state, locationPlans: [], selectedPlan: undefined}, () => {
                        if (this.state.selectedLocation) {
                          this.reloadPlans(this.state.selectedLocation)
                        }
                      })
                    })
                    .catch(e => {
                      if (e.response && e.response.data) {
                        this.setState({...this.state, exception: e.response.data})
                      }
                    })
                })
              } else {
                this.setState({...this.state, exception: this.confirmDeletePlanMsg})
              }
            }}
          >
            Изтрий този план
          </button>
        ) : null}
      </>
    )
  }

  copyRegPlanFeatures(): ISourceDescriptions {
    const sourceDescriptions: ISourceDescriptions = {}
    if (this.state.selectedPlan) {
      const where = `"RegPlanId" = ${this.state.selectedPlan.get('Id')}`
      const groupName = `Арх. ул. рег: ${this.state.selectedPlan.get('PlanName')} от ${getDateString(
        new Date(this.state.selectedPlan.get('PlanDate'))
      )}`
      for (const id in this.props.layerInfos) {
        const streetRegUrls = [
          appConfig.streetreg.arealines.url,
          appConfig.streetreg.area.url,
          appConfig.streetreg.os.url,
          appConfig.streetreg.points.url,
          appConfig.streetreg.troto.url
        ]
        if (streetRegUrls.indexOf(id) != -1) {
          const desc = JSON.parse(JSON.stringify(this.props.layerInfos[id].sourceDescription)) as ISourceDescription
          desc.id = desc.id + uuidv4()
          desc.visible = true
          desc.readOnly = true
          desc.noLegend = false
          if (id == appConfig.streetreg.area.url) {
            desc.noLegend = true
          }
          desc.sourceTitle = groupName + ' / ' + desc.layerName
          desc.constantSqlWhere = where
          desc.group = groupName
          if (desc.vectorRenderer) {
            if (desc.vectorRenderer!.nomenclature && desc.vectorRenderer!.nomenclature!.values) {
              for (const i in desc.vectorRenderer!.nomenclature!.values) {
                const def = desc.vectorRenderer!.nomenclature!.values[i]!
                def.forEach(s => {
                  if (s.stroke) {
                    const stateStrokeColor = this.state.parcels.strokeColor
                    s.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
                  }
                  if (s.fill) {
                    const fillColor = this.state.parcels.fillColor
                    s.fill.color = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
                  }
                  if (s.text) {
                    const fillColor = this.state.parcels.textColor
                    s.text.fillColor = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
                  }
                })
              }
            } else if (desc.vectorRenderer!.def) {
              desc.vectorRenderer!.def!.forEach(s => {
                if (s.stroke) {
                  const stateStrokeColor = this.state.parcels.strokeColor
                  s.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
                }
                if (s.fill) {
                  const fillColor = this.state.parcels.fillColor
                  s.fill.color = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
                }
                if (s.text) {
                  const fillColor = this.state.parcels.textColor
                  s.text.fillColor = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
                }
                if (s.circle) {
                  if (s.circle.stroke) {
                    const stateStrokeColor = this.state.parcels.strokeColor
                    s.circle.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
                  }
                }
              })
            }
          }
          // desc.pseudoViewSchema = { 0: ViewSchemaType.None, 17: ViewSchemaType.Vector }

          sourceDescriptions[id] = desc
        }
      }
    }

    return sourceDescriptions
  }

  reloadPlans(selectedLocation: Feature) {
    const planInfo = this.props.layerInfos[appConfig.streetreg.streetplan.url]
    ServiceHub.gisCrudService
      .execute(planInfo, {
        where: `"LocalityId" = ${selectedLocation.getProperties()['Id']}`,
        orderByFields: ['PlanDate DESC']
      })
      .then(r => {
        if (r.length > 1) {
          this.setState({...this.state, locationPlans: r, loading: false, selectedPlan: r[0]})
        } else {
          this.setState({...this.state, locationPlans: [], loading: false, selectedPlan: undefined}, () => {
            this.setSelectedPlan(undefined)
          })
        }
      })
      .catch(e => {
        this.setState({...this.state, locationPlans: [], loading: false})
      })
  }

  getLoactionSelector() {
    return (
      <LocationSelector
        onSettlementsChange={(locs, selectedSettlemet?: Feature, selectedLocation?: Feature) => {
          this.setState(
            {...this.state, selectedLocation: selectedLocation, selectedSettlemet: selectedSettlemet, loading: true},
            () => {
              if (selectedLocation) {
                this.reloadPlans(selectedLocation)
              } else {
                this.setState({...this.state, locationPlans: [], loading: false})
              }
            }
          )
        }}
        selectedLocation={this.state.selectedLocation}
        selectedSettlemet={this.state.selectedSettlemet}
      />
    )
  }

  getAddPlanOnMapButton() {
    return (
      <>
        <button
          type="button"
          className="button width"
          disabled={!this.state.selectedPlan}
          onClick={() => {
            this.setState({...this.state, exception: '', loading: true, success: ''})
            const sourceDescriotions = this.copyRegPlanFeatures()
            ServiceHub.SourcesService.getInfosFromSources(sourceDescriotions)
              .then(payload => {
                this.props.dispatchSources(payload)
                this.setState({...this.state, exception: '', loading: false, success: 'Успешно добавени'})
              })
              .catch(e => {
                this.setState({...this.state, exception: 'Възникна грешка', loading: false})
              })
          }}
        >
          Добави плана на картата
        </button>
      </>
    )
  }

  getObjectColorPickers(title: string, value: RGBColor, setColor: (color: RGBColor) => void) {
    return (
      <div>
        <SliderPicker
          color={value}
          onChange={c => {
            setColor({r: c.rgb.r, g: c.rgb.g, b: c.rgb.b})
          }}
        />
        <AlphaPicker
          color={value}
          onChange={c => {
            setColor(c.rgb)
          }}
        />
      </div>
    )
  }

  getParcelColorPickers() {
    return (
      <div className="color-reg-pickers-section">
        <div style={{padding: '10px'}}>
          {this.getObjectColorPickers('Цветове', this.state.parcels.strokeColor, (rgb: RGBColor) => {
            this.setState({
              ...this.state,
              parcels: {
                ...this.state.parcels,
                strokeColor: {...this.state.parcels.strokeColor, ...rgb},
                fillColor: {...this.state.parcels.fillColor, ...rgb},
                textColor: {...this.state.parcels.textColor, ...rgb}
              }
            })
          })}
        </div>
      </div>
    )
  }

  getColoPickers() {
    return (
      <div>
        <h3>Изберете цвят на добавения план</h3>
        {this.getParcelColorPickers()}
      </div>
    )
  }
  getProjectionSelector(): JSX.Element {
    return (
      <CsSelectorLite
        className="form-control"
        selected={this.state.exportCs}
        onChange={s => {
          this.setState({...this.state, exportCs: s})
        }}
      />
    )
  }
  getExportPlanAsDxf() {
    return this.props.user && (this.props.user.isAdmin || this.props.user.isRegAdmin) ? (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div>Експорт</div>
          <div
            style={{
              padding: '10px 0',
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {this.getProjectionSelector()}
            <button
              type="button"
              className="button width"
              disabled={!this.state.selectedPlan}
              onClick={() => {
                this.setState({...this.state, exception: '', success: '', loading: true})
                Axios.post(appConfig.urls.xyApiUrl + '/StreetExportPlan', {
                  DestinationCS: this.state.exportCs,
                  PlanId: this.state.selectedPlan!.getProperties()['Id'],
                  Differences: false //this.state.addChangesOnly
                })
                  .then(r => {
                    this.setState({
                      ...this.state,
                      exception: '',
                      success: 'Успешен експорт',
                      exportedPlan: appConfig.urls.xyApiUrl + '/' + r.data.PATH,
                      loading: false
                    })
                  })
                  .catch(() => {
                    this.setState({...this.state, exception: 'Възникна грешка', success: '', loading: false})
                  })
              }}
            >
              Експорт в DXF
            </button>
          </div>
        </div>
        {this.state.exportedPlan ? (
          <div style={{padding: '10px'}}>
            <a href={this.state.exportedPlan} target="_blank" style={{wordBreak: 'break-all'}} rel="noreferrer">
              {this.state.exportedPlan}
            </a>
          </div>
        ) : null}
      </div>
    ) : null
  }

  protected getPlanActions(selectedPlan: Feature) {
    return (
      <React.Fragment>
        {this.getColoPickers()}
        {this.getAddPlanOnMapButton()}
        <br></br>
      </React.Fragment>
    )
  }

  render() {
    return (
      <div className="reg-history">
        <OverlayLoader show={this.state.loading}></OverlayLoader>
        {this.getLoactionSelector()}
        {this.state.selectedSettlemet ? (
          <>
            <br></br>
            {this.getDeleteAll()}
          </>
        ) : null}
        {this.state.selectedLocation ? (
          <>
            <br></br>
            {this.getDeleteLocality()}
          </>
        ) : null}

        <br></br>
        {this.getPlanSelector()}
        {this.state.selectedPlan ? (
          <>
            <br></br>
            {this.getDeletePlan()}
          </>
        ) : null}
        <div style={{position: 'relative'}}>
          <OverlayLoader show={this.state.loading}></OverlayLoader>
          <br></br>
          {this.state.selectedPlan ? this.getPlanActions(this.state.selectedPlan) : null}

          {this.getExportPlanAsDxf()}
          {this.state.exception &&
          this.state.exception != this.confirmDeleteMsg &&
          this.state.exception != this.confirmDeleteLocMsg &&
          this.state.exception != this.confirmDeletePlanMsg ? (
            <div className="error-div">{this.state.exception}</div>
          ) : null}
          {this.state.success ? <div className="success-div">{this.state.success}</div> : null}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IAppStore) => {
  return {
    layerInfos: state.layerInfos.featureLayerInfos,
    user: state.userInfo.user
  }
}
//<OwnProps, DispatchProps, ParentProps>
export const StreetHistory = connect(mapStateToProps, {
  ...appSourcesDispatcher
})(StreetHistoryClass)
